import React from 'react';
import { IPhenologySpecificTreeEntryBranch, PhenologySpecificTreeEntryHelper } from '../../../../types/model/phenology/specificEntry';
import { Box, styled } from '@material-ui/core';
import { themeVariables } from '../../../../material';

interface IPhenologySpecificTreeEntryBranchViewProps {
    branches : Array<IPhenologySpecificTreeEntryBranch>;
}

interface IPhenologySpecificTreeEntryBranchViewState {}

export default class PhenologySpecificTreeEntryBranchView extends React.PureComponent<IPhenologySpecificTreeEntryBranchViewProps, IPhenologySpecificTreeEntryBranchViewState> {
    constructor(props : IPhenologySpecificTreeEntryBranchViewProps) {
        super(props);
        this.state = {};
    }

    private readonly StyledBox = styled(Box)({
        '& > div': {
            marginBottom: 15,
        },
        '& .header': {
            height: 38,
            color: themeVariables.colors.white,
            backgroundColor: '#098442',
            boxShadow: '0px 3px 6px #00000047',
            borderRadius: 4,
        },
        '& .header div': {
            height: 38,
            fontWeight: 500,
            fontSize: 11,
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .row': {
            height: 38,
            color: '#464646',
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 3px 6px #00000047',
            borderRadius: 4,
            alignItems: 'center',
        },
        '& .row div': {
            height: 30,
            fontWeight: 500,
            fontSize: 11,
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .row div:first-child': {
            color: '#FFFFFF',
            fontWeight: 700,
            backgroundColor: '#FF7F00',
            borderRadius: 6,
            maxWidth: 71,
            margin: '0px 10px',
        },
        '& .header div:first-child': {
            maxWidth: 71,
            margin: '0px 8px',
        },
        '& .total.row div:first-child': {
            backgroundColor: '#FF5050 !important',
        },
        '& .total.row div': {
            fontWeight: 700,
        },
    });

    public readonly render = () => {

        const branches = this.props.branches.filter(x => x.branchLength);
        const totalLength = branches.reduce((value, branch) => value + (branch.branchLength ?? 0), 0);
        return (
            <this.StyledBox className='fdc'>
                <div className='fdr header'>
                    <div className='flx1'>
                        BRANCH NO
                    </div>
                    <div className='flx1'>
                        LENGTH
                    </div>
                    {
                        PhenologySpecificTreeEntryHelper.spurs.map((spur) => (
                            <div key={spur} className='flx1'>
                                {
                                    spur > -1 &&
                                    <>
                                        {
                                            spur
                                        }
                                        &nbsp;POINTER
                                    </>
                                }
                                {
                                    spur <= -1 &&
                                    'CLUSTER'
                                }
                            </div>
                        ))
                    }
                </div>
                <div className='fdr row total'>
                    <div className='flx1'>
                        TOTAL
                    </div>
                    <div className='flx1'>
                        {
                            totalLength
                        }
                        &nbsp;CM
                    </div>
                    {
                        PhenologySpecificTreeEntryHelper.spurs.map((spur) => (
                            <div key={spur} className='flx1'>
                                {
                                    branches.some(x => !!x.spurs[spur]) &&
                                    branches.reduce((value, branch) => value + (branch.spurs[spur]), 0)
                                }
                                {
                                    !branches.some(x => !!x.spurs[spur]) &&
                                    '-'
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    branches.filter(x => x.branchLength).map((branch, i) => (
                        <div key={i} className='fdr row'>
                            <div className='flx1'>
                                {i + 1}
                            </div>
                            <div className='flx1'>
                                {
                                    branch.branchLength
                                }
                                &nbsp;CM
                            </div>
                            {
                                PhenologySpecificTreeEntryHelper.spurs.map((spur) => (
                                    <div key={spur} className='flx1'>
                                        {
                                            !!branch.spurs[spur] &&
                                            branch.spurs[spur]
                                        }
                                        {
                                            !branch.spurs[spur] &&
                                            '-'
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </this.StyledBox>
        );
    };
}
